export function getTonConnectErrorMessage(error: unknown): string {
  const message = error instanceof Error ? error.message : String(error ?? "");

  if (/UserRejects|user rejects|rejected|declined/i.test(message)) {
    return "交易已取消";
  }

  if (/WalletNotConnected|not connected|connect wallet/i.test(message)) {
    return "钱包连接已失效，请重新连接后再试";
  }

  if (/not enough balance|insufficient funds|余额不足/i.test(message)) {
    return "钱包余额不足，创建代币至少需要 6 TON（包含服务费和网络费）";
  }

  if (/SendTransactionRequest validation failed.*address|Wrong 'address' format/i.test(message)) {
    return "交易地址格式错误，请刷新页面后重新提交";
  }

  if (/BadRequest|CM Unhandled error|Unhandled error/i.test(message)) {
    return "钱包无法处理这笔交易，请确认余额至少为 6 TON，更新钱包并重新连接后再试";
  }

  if (/timeout/i.test(message)) {
    return "交易已提交，但等待链上确认超时，请稍后在钱包中查看交易状态";
  }

  return message || "创建代币失败，请稍后重试";
}
